import Root from './components';
import './App.css';
//import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
 <Root />
    </div>
  );
}

export default App;
